module.exports = __webpack_public_path__ + "static/media/privacy.d4a0134e.svg";